<div class="kanaal-input">
    @if (this.showLabel()) {
        @let label = this.showTypeLabel() ? this.ioType.toString() : ("Kanaal" | translate: "Kanaal");
        <div [class.invalid]="!this.isValid">
            {{label}} 
        </div>
    
    }

    <kendo-numerictextbox #kanaalTextBox [value]="this.start" [min]="0" [max]="this.maxKanaal()" [autoCorrect]="true" 
        (valueChange)="onKanaalChange($event)"
        (blur)="this.validateKanaal(true)"
        format="n0" [style]="{ width: '100px' }"></kendo-numerictextbox>

    @if (canChoose()) {
    <button kendoButton (click)="this.onShowSelector()">{{'Kies' | translate: 'Kies'}}</button>
    <button kendoButton (click)="this.onAutoFill()" [svgIcon]="arrowRotateCcwIcon" 
        [title]="this.autoFillOutOfRange ? ('Onvoldoende beschikbare kanalen aan het einde. Pas de hardware configuratie [Hdw Config] aan of kies handmatig!' | translate: 'Onvoldoende beschikbare kanalen aan het einde. Pas de hardware configuratie [Hdw Config] aan of kies handmatig!') : null"
        [themeColor]="this.autoFillOutOfRange ? 'error' : 'base'"></button>
    }
    <div class="checkboxes" *ngIf="this.showCheckboxes()">
        @if (this.hasAKanaal() && !this.virtualAI()) {
        <div class="checkbox">
            <kendo-checkbox #isACheckbox [checkedState]="this.isA"
                (checkedStateChange)="onAKanaalChange($event)"></kendo-checkbox>
            <kendo-label [for]="isACheckbox" text="A Kanaal">
            </kendo-label>

        </div>
        }
        @if (this.hasInverted()) {
        <div class="checkbox">
            <kendo-checkbox #invertedChk [checkedState]="this.inverted" style="align-self: center;"
                (checkedStateChange)="onInvertedChange($event)"></kendo-checkbox>
            <kendo-label [for]="invertedChk" text="{{'Inverteer' | translate: 'Inverteer'}}">
            </kendo-label>
        </div>
        }
        @if (this.hasVolt()) {
        <div class="checkbox">

            <kendo-checkbox #voltChk [checkedState]="this.volt" style="align-self: center;"
                (checkedStateChange)="onVoltChanged($event)"></kendo-checkbox>
            <kendo-label [for]="voltChk" text="2 - 10 V">
            </kendo-label>
        </div>
        }

    </div>


</div>

<kendo-dialog *ngIf="this.showSelector" [title]="this.ioType.toString()" width="1300px"
    (close)="this.showSelector = false">
    <div>
        <kanaal-selector [kanaalType]="this.ioType" (onKanaalSelected)="onKanaalSelected($event)"
            [initialPresentation]="this.kanaalService.prefferedPresentation()"
            (presentationChanged)="this.kanaalService.prefferedPresentation.set($event)"
            [initialSelection]="this.kanaalSelection" [range]="this.range" [assign]="this.assign()"
            [system]="this.hdwConfigService.system()"></kanaal-selector>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.showSelector = false">Close</button>
        <button kendoButton (click)="this.onOK()" themeColor="primary">Select</button>
    </kendo-dialog-actions>
</kendo-dialog>